import script from "./ToolsCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsCollection.vue?vue&type=script&setup=true&lang=js"

import "./ToolsCollection.vue?vue&type=style&index=0&id=3ac9a52b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac9a52b"]])

export default __exports__